// Groups notes into threads for the profile notes panels.

function safeList(value) {
  return Array.isArray(value) ? value : [];
}

/* Groups notes into threads and orders them by last activity.

   A reply bumps its whole thread to the top, so the conversation someone just
   answered is the first thing the next person sees. Within a thread the replies
   read oldest-first, which is how a conversation is read. */
export function buildThreads(notes) {
  const list = safeList(notes).filter((note) => note && note.id);
  const parents = list.filter((note) => !note.parentId);
  const repliesByParent = new Map();
  list.filter((note) => note.parentId).forEach((reply) => {
    if (!repliesByParent.has(reply.parentId)) repliesByParent.set(reply.parentId, []);
    repliesByParent.get(reply.parentId).push(reply);
  });

  const threads = parents.map((parent) => {
    const replies = (repliesByParent.get(parent.id) || [])
      .slice()
      .sort((left, right) => String(left.createdAt || '').localeCompare(String(right.createdAt || '')));
    const newestReply = replies.length ? replies[replies.length - 1] : null;
    const activity = parent.lastActivityAt
      || (newestReply ? newestReply.createdAt : parent.createdAt);
    return { parent, replies, activity: String(activity || ''), newestReply };
  });

  // An orphaned reply -- its parent deleted -- would otherwise vanish, so it is
  // promoted to a thread of its own rather than being silently dropped.
  const parentIds = new Set(parents.map((note) => note.id));
  list
    .filter((note) => note.parentId && !parentIds.has(note.parentId))
    .forEach((orphan) => {
      threads.push({ parent: orphan, replies: [], activity: String(orphan.createdAt || ''), newestReply: null });
    });

  threads.sort((left, right) => right.activity.localeCompare(left.activity));
  return threads;
}

// Deleting a comment never deletes another author's replies.
export function notesAfterDelete(notes, id) {
  return safeList(notes).filter((note) => note.id !== id).map((note) => ({
    ...note,
    ...(note.parentId === id ? { parentId: null } : {}),
    ...(note.parent_id === id ? { parent_id: null } : {}),
  }));
}
